import { useParams } from "react-router";
import {
  TreatmentComponent,
  TreatmentComponentSkeleton,
} from "@/services/backend/vbs/treatments/components/treatment-component";
import { Column } from "@/services/backend/vbs/treatments/lib/treatment-component-state";
import { useVbsOrderShowQuery } from "@/services/backend/vbs/orders/api/order-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Textblocks } from "@/services/backend/textblocks/components/textblocks";
import { GSMSubdomain } from "@/shared/types/gsm-subdomain";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import t from "@/lang/lang";
import { TreatmentRemark } from "@/services/backend/vbs/treatments/components/treatment-remark";

export function OrderTreatmentRoute() {
  const { orderId } = useParams();

  const {
    data: order,
    isLoading,
    error,
  } = useVbsOrderShowQuery({
    id: orderId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return <TreatmentComponentSkeleton />;
  }

  return (
    <div className="grid gap-2">
      <TreatmentComponent
        treatmentId={order!.treatmentId}
        availableColumns={[
          Column.Position,
          Column.ComponentKind,
          Column.ComponentData,
          Column.Cycle,
          Column.Formula,
          Column.CleanTime,
          Column.BasePrice,
          Column.CycleDiscount,
          Column.SpecialDiscount,
          Column.FinalPrice,
          Column.Comment,
          Column.Actions,
        ]}
        defaultColumns={[
          Column.Position,
          Column.ComponentKind,
          Column.BasePrice,
          Column.CycleDiscount,
          Column.FinalPrice,
          Column.Comment,
          Column.Actions,
        ]}
      />
      <TreatmentRemark treatmentId={order!.treatmentId} />
      <Textblocks
        subdomain={GSMSubdomain.VBS}
        documentKind={GSMDocumentKind.Treatment}
        documentId={order!.treatmentId}
        title={t("Allgemeine Bemerkungen im Leistungsverzeichnis")}
        defaultOpen={false}
      />
    </div>
  );
}
